import { useMutation, queryCache } from "react-query-legacy";
import { message } from "antd";
import { BillingEngineService } from "services";
import { hoursLoggedQueryKey } from "../constants";
import { WarehouseLogHoursForm } from "../Modal/LogHoursModal";

function createWarehouseHours(values: WarehouseLogHoursForm) {
  const { projectType, id, facility, ...rest } = values;

  const record: any = {
    ...rest,
    date: values.date.toISOString(),
    hoursWorked: values.hoursWorked || 0,
    minutesWorked: values.minutesWorked || 0,
    status: "pending",
  };

  if (projectType === "special-projects") {
    record.organizationId = id;
    record.facilityCode = facility.code;
  }

  if (projectType === "wros") {
    record.wroId = id;
  }

  return BillingEngineService.createWarehouseHours({
    type: projectType,
    record: record,
  });
}

function useQueryCreateHours() {
  return useMutation(createWarehouseHours, {
    onSuccess: (response, { projectType }) => {
      message.success("Created row");
      queryCache.refetchQueries([hoursLoggedQueryKey, projectType]);
    },
  });
}

export default useQueryCreateHours;
